import StyleList from "@/components/StyleList";
import useOnboardingContext from "@/hooks/useOnboardingContext"
import { TEMPLATE_STYLE_LIST } from "@/constants/onboarding";
import { FONTS } from '@/constants/onboarding'
import { getDefaultTemplate } from '../../../../helpers/updateTemplateUtil'

const WizardStep1 = () => {
  const { 
      templateStyle,
      setTemplateStyle,
      setSelectedFont,
      setSelectedPalette,
      setCustomFont,
      defaultTemplatesVersion
   } = useOnboardingContext()

   const templateStyleHandler = (templateStyle) => {
    setTemplateStyle(templateStyle)
   
    const template = getDefaultTemplate(templateStyle, defaultTemplatesVersion)
    const defaultFont = FONTS[templateStyle][template.version][0]
   
    setSelectedFont(defaultFont);

    setSelectedPalette();
    setCustomFont();
  }

  return (
    <StyleList
      selected={templateStyle}
      onChange={templateStyleHandler}
      items={TEMPLATE_STYLE_LIST}
    />
  );
};

export default WizardStep1;
